/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 09:41:27
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 11:14:51
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/CustomerGets/index.tsx
 */
import { Checkbox, Label, Select } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form, InputNumber } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import CollectionTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CollectionTable';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
import AtDiscountValue from '../../../Components/AtDiscountValue';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
// import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import css from '../css.module.less';

export enum TypeOptionsType {
  All = 'All',
  Any = 'Any',
}
export enum ProductsOptionsType {
  Collections = 'Collections',
  Products = 'Products',
}

const CustomerGets = ({ currency, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const typesOptions = [
    {
      label: getI18n('salesChannelGiftPurchase.customerGets.allitems'),
      value: TypeOptionsType.All,
    },
    {
      label: getI18n('salesChannelGiftPurchase.customerGets.anyitems'),
      value: TypeOptionsType.Any,
    },
  ];
  const productsOptions = [
    {
      label: getI18n(
        'salesChannelDirectDiscount.discountValuebuyOne.specificCollections',
      ),
      value: ProductsOptionsType.Collections,
    },
    {
      label: getI18n(
        'salesChannelDirectDiscount.eligibalCondition.specificProducts',
      ),
      value: ProductsOptionsType.Products,
    },
  ];
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.databaseSettingTableContainer}
        title={getI18n('salesChannelGiftPurchase.customerGets.customerGets')}>
        <div className={css.getsItems}>
          <Form.Item
            name={['discountMethod', 'getsQty']}
            label={`${getI18n('general.quantity')}*`}
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  getI18n('general.quantity'),
                ),
              },
            ]}
            labelCol={{ span: 24 }}>
            <InputNumber
              size='large'
              min={1}
              precision={0}
              className={css.inputNumber}
              disabled={disableEdit}
            />
          </Form.Item>
          <div className={css.interval}>{getI18n('general.of')}</div>
          <Form.Item
            name={['discountMethod', 'purchaseType']}
            label={getI18n('salesChannelGiftPurchase.customerGets.types')}
            labelCol={{ span: 24 }}>
            <Select
              size='large'
              options={typesOptions}
              disabled={disableEdit}></Select>
          </Form.Item>
          <div className={css.interval}>{getI18n('general.from')}</div>
          <Form.Item
            name={['discountMethod', 'purchaseItemScope']}
            label={getI18n('general.products')}
            labelCol={{ span: 24 }}>
            <Select
              size='large'
              options={productsOptions}
              disabled={disableEdit}></Select>
          </Form.Item>
        </div>
        <Form.Item
          noStyle
          shouldUpdate={(p, c) =>
            p.discountMethod.purchaseItemScope !==
            c.discountMethod.purchaseItemScope
          }>
          {({ getFieldValue }) =>
            getFieldValue(['discountMethod', 'purchaseItemScope']) ==
            'Products' ? (
              <Form.Item
                name={['discountMethod', 'products']}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'general.advancedFilters.commonRadioMulSelect.selectItem',
                    ),
                  },
                ]}>
                <ProductTable
                  currency={currency}
                  disableEdit={disableEdit}
                  withMultiCurrency={true}
                />
              </Form.Item>
            ) : (
              <Form.Item
                name={['discountMethod', 'collections']}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'general.commonRadioMulSelect.pleaseselectatleastoneitem',
                    ),
                  },
                ]}>
                <CollectionTable
                  currency={currency}
                  disabled={disableEdit}
                  withMultiCurrency={true}
                />
              </Form.Item>
            )
          }
        </Form.Item>
        <div className={css.splitLine}></div>
        <Label
          title={getI18n(
            'salesChannelGiftPurchase.customerGets.ataDiscountValue',
          )}
        />
        <div className={css.discountValue}>
          <AtDiscountValue
            currency={currency}
            radioName={['discountMethod', 'discountValue']}
            percentageName={['discountMethod', 'percentage']}
            reductionAmountName={['discountMethod', 'reductionAmount']}
            disableEdit={disableEdit}
          />
        </div>

        <div className={css.splitLine}></div>
        <Form.Item name={['applyTo', 'cumulative']} valuePropName={'checked'}>
          <Checkbox disabled={disableEdit}>
            {getI18n('salesChannelGiftPurchase.customerGets.applyTip')}
          </Checkbox>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(p, c) =>
            get(p, 'applyTo.cumulative', '') !==
              get(c, 'applyTo.cumulative', '') ||
            get(p, 'discountMethod.maxSelectionEnabled', '') !==
              get(c, 'discountMethod.maxSelectionEnabled', '')
          }>
          {({ getFieldValue }) => (
            <Fragment>
              {getFieldValue(['applyTo', 'cumulative']) && (
                <Form.Item
                  name={['discountMethod', 'maxSelectionEnabled']}
                  className={css.maxSelectionEnabled}
                  valuePropName={'checked'}>
                  <Checkbox disabled={disableEdit}>
                    {getI18n(
                      'salesChannelGiftPurchase.customerGets.maxNumberItem',
                    )}
                  </Checkbox>
                </Form.Item>
              )}
              {getFieldValue(['applyTo', 'cumulative']) &&
                getFieldValue(['discountMethod', 'maxSelectionEnabled']) && (
                  <Form.Item
                    name={['discountMethod', 'maxSelection']}
                    rules={[
                      {
                        required: true,
                        message: getI18n('general.pleasefillthisfield'),
                      },
                    ]}>
                    <InputNumber
                      size='large'
                      min={1}
                      precision={0}
                      className={css.maxSelection}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                )}
            </Fragment>
          )}
        </Form.Item>
        <div className={css.splitLine}></div>
        <Form.Item
          noStyle
          shouldUpdate={(p, c) =>
            get(p, 'discountMethod.purchaseType', '') !== //maxProductEnabled,maxProduct
              get(c, 'discountMethod.purchaseType', '') ||
            get(p, 'discountMethod.maxProductEnabled', '') !==
              get(c, 'discountMethod.maxProductEnabled', '')
          }>
          {({ getFieldValue }) => (
            <Fragment>
              {getFieldValue(['discountMethod', 'purchaseType']) ===
                TypeOptionsType.Any && (
                <Fragment>
                  <Form.Item
                    name={['discountMethod', 'maxProductEnabled']}
                    className={css.maxSelectionEnabled}
                    valuePropName={'checked'}>
                    <Checkbox disabled={disableEdit}>
                      {getI18n(
                        'salesChannelGiftPurchase.customerGets.maxSelect',
                      )}
                    </Checkbox>
                  </Form.Item>
                  {getFieldValue(['discountMethod', 'maxProductEnabled']) && (
                    <Form.Item
                      name={['discountMethod', 'maxProduct']}
                      rules={[
                        {
                          required: true,
                          message: getI18n('general.pleasefillthisfield'),
                        },
                      ]}>
                      <InputNumber
                        size='large'
                        min={1}
                        precision={0}
                        className={css.maxSelection}
                        disabled={disableEdit}
                      />
                    </Form.Item>
                  )}
                  <div className={css.splitLine}></div>
                </Fragment>
              )}
            </Fragment>
          )}
        </Form.Item>
        <div>
          <h3 className={css.tipTitle}>
            {getI18n(
              'salesChannelDirectDiscount.discountValue.discountCalculationrule',
            )}
          </h3>
          <p className={css.tipContent}>
            {getI18n('salesChannelGiftPurchase.customerGets.shooperEnd')}
          </p>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default CustomerGets;
